import { getCurrentSensorTestPicture, getImageStr, testCameraConnect } from "@/api/device/sensor"
import { CameraTest, Sensor } from "@/global/interface/device/sensor"
import { useEffect, useState } from "react"
import { Image } from "antd";

interface Iprops {
    sensor: Sensor
    setImg?: (img: string) => void
}


enum CameraStatus {
    /**
     * 正常
     */
    normal,
    /**
     * 设备异常
     */
    deviceError,
    /**
     * 标定异常
     */
    calibrationError,
}

export function MonitorImagePanel(props: Iprops) {
    const [base64Img, setBase64Img] = useState<string>(null)   //base64格式的图片信息

    const [cameraStatus, setCameraStatus] = useState<CameraStatus>(null);  // 摄像头状态
    const [nowCurrentData, setNowCurrentData] = useState<number>(null);    // 当前时间戳


    useEffect(() => {
        setNowCurrentData(Date.now());
        setCameraStatus(null);
        setBase64Img(null);
    }, [props.sensor])

    useEffect(() => {
        flushData();
        const interval = setInterval(() => {
            flushData();
        }, 5000)

        return () => {
            clearInterval(interval)
        }
    }, [props.sensor])


    const flushData = () => {
        if (props.sensor && props.sensor.id && props.sensor.sensorParameters && props.sensor.sensorParameters.length > 0) {
            const videoParams = props.sensor.sensorParameters.filter(item => item.symbol === "video");
            if (videoParams.length > 0) {
                // 认为是摄像头传感器

                // getCurrentSensorTestPicture(props.sensor.id).then(res => {
                //     const data: CameraTest = res?.data;
                //     if (data != null && data.time != null && data.time > nowCurrentData - 3 * 60 * 1000) {//如果测试3分钟前有图，认为正常
                //         setTimeout(() => {
                //             setCameraStatus(CameraStatus.normal);
                //         }, 2000);

                //     } else {
                //         setTimeout(() => {
                //             setCameraStatus(CameraStatus.deviceError);
                //         }, 2000);
                //     }
                // })
                // testCameraConnect(props.sensor.id);



                let paramId = videoParams[0]?.id;
                getImageStr(paramId, "image").then(res2 => {
                    if (res2.status && res2.data) {
                        if (props.setImg) {
                            props.setImg(res2.data.image);
                        }
                        setBase64Img(res2.data.image);
                    } else {
                        let paramId2 = videoParams[1]?.id;
                        if (paramId2 != null) {
                            getImageStr(paramId2, "image").then(res3 => {
                                if (res3.status && res3.data) {
                                    if (props.setImg) {
                                        props.setImg(res3.data.image);
                                    }
                                    setBase64Img(res3.data.image);
                                }
                            })
                        }

                    }
                })
            }
        }
    }

    return (
        <>
            {
                base64Img &&
                <>
                    <Image
                        src={`data:image/jpeg;base64,${base64Img}`}
                    />
                </>
            }
            {
                !base64Img &&
                <>
                    {cameraStatus === CameraStatus.deviceError && <div className="error-image">设备异常或设备连接异常</div>}
                    {cameraStatus === CameraStatus.normal && <div className="error-image">未标定</div>}
                    {cameraStatus == null && <div className="empty-image">正在获取数据...</div>}
                </>
            }
        </>
    )

}